import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import BackgroundCanvas from "@/components/BackgroundCanvas";
import HomePage from "@/pages/HomePage";
import ExchangePage from "@/pages/ExchangePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import OperatorDashboard from "@/pages/OperatorDashboard";
import UserHistoryPage from "@/pages/UserHistoryPage";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import UserCabinetNew from "@/pages/UserCabinetNew";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AboutPage from "@/pages/AboutPage";
import AMLPage from "@/pages/AMLPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FAQPage from "@/pages/FAQPage";
import TermsPage from "@/pages/TermsPage";
import LiveChat from "@/components/LiveChat";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BackgroundCanvas />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/exchange" element={<ExchangePage />} />
            <Route path="/history" element={<UserHistoryPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/cabinet" element={<UserCabinetNew />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/aml" element={<AMLPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/analytics" element={<AnalyticsDashboard />} />
            <Route path="/operator/dashboard" element={<OperatorDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <LiveChat />
      </div>
    </LanguageProvider>
  );
}

export default App;